import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { X } from "lucide-react";
import { useI18n } from "../context/I18nContext";

export default function Gallery() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="gallery-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-12">
        <div className="overline">{t("galleryPage.overline")}</div>
        <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl mt-5 leading-none">
          {t("galleryPage.titleA")} <span className="text-[#00A896]">{t("galleryPage.titleB")}</span>
        </h1>
        <p className="text-[#8C939D] max-w-xl mt-6 leading-relaxed">{t("galleryPage.intro")}</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        {items.length === 0 ? (
          <div className="brut-card p-16 text-center">
            <div className="overline text-[#8C939D]">{t("galleryPage.comingSoon")}</div>
            <p className="text-[#C7CBD3] mt-4">{t("galleryPage.empty")}</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((g) => (
              <button
                key={g.id}
                onClick={() => setActive(g)}
                className="brut-card aspect-square overflow-hidden group"
                data-testid={`gallery-item-${g.id}`}
              >
                <img src={g.image} alt={g.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </button>
            ))}
          </div>
        )}
      </section>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="gallery-lightbox">
          <button className="absolute top-6 right-6 text-white" onClick={() => setActive(null)}><X size={28} /></button>
          <img src={active.image} alt={active.title} className="max-h-[85vh] max-w-[95vw] object-contain border border-[#00A896]" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
